import { ActionType } from '@editor/src/js/constants/common-action-type';

export const INTELLIGENT_TOOL_LOADED_FLAG = `${ActionType.INTELLIGENT_TOOL}-load`;
export const INSERT_IFRAME_LOADED_FLAG = `${ActionType.INSERT_IFRAME}-load`;
